// Internal design system styles (preflight + utilities)
import "@instacover/ui/styles.css"
import "./index.css"
import "@fontsource/open-sans/300.css"
import "@fontsource/open-sans/400.css"
import "@fontsource/open-sans/500.css"
import "@fontsource/open-sans/600.css"
import "@fontsource/open-sans/700.css"
import "@fontsource/open-sans/800.css"
import "@fontsource/open-sans/300-italic.css"
import "@fontsource/open-sans/400-italic.css"
import "@fontsource/open-sans/500-italic.css"
import "@fontsource/open-sans/600-italic.css"
import "@fontsource/open-sans/700-italic.css"
import "@fontsource/open-sans/800-italic.css"

import { StrictMode } from "react"
import ReactDOM from "react-dom/client"

import { App } from "./App"
import { startBackgroundUploader } from "./helpers/backgroundUploader"

const rootElementId = "root"
const rootElement = document.getElementById(rootElementId)
if (!rootElement) {
  throw new Error(`Root element with id ${rootElementId} not found.`)
}

const root = ReactDOM.createRoot(rootElement)
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)

startBackgroundUploader()
